<script lang="ts">
import { ref, markRaw, type Component, type VNodeProps, type AllowedComponentProps, computed } from 'vue';
import type { ModalConfig, ModalOptions } from '../modals/modal-types';

type ComponentProps<C extends Component> = C extends new (...args: any) => any
  ? Omit<InstanceType<C>['$props'], keyof VNodeProps | keyof AllowedComponentProps>
  : never;

const modals = ref<ModalConfig[]>([]);
let modalIdNext = 0;

export function modalRegister<C extends Component, R>(
  component: C,
  props: ComponentProps<C>,
  options: ModalOptions = {},
): Promise<R | null> {
  const id = modalIdNext++;
  return new Promise<R | null>((resolve) => {
    modals.value.push({ id, component: markRaw(component), props, onClose: resolve as any, options });
  }).finally(() => {
    const index = modals.value.findIndex((m) => m.id === id);
    if (index !== -1) {
      modals.value.splice(index, 1);
    }
  });
}

export const isModalShowing = computed(() => modals.value.length > 0);
</script>

<script setup lang="ts">
import Modal from '../modals/Modal.vue';
</script>

<template>
  <div>
    <Modal v-for="modal of modals" :key="modal.id" :config="modal" />
  </div>
</template>
